export type BookingDateFilterModeWire = 'startDate' | 'overlapRange';

export type BookingSearchMatchField =
  | 'bookingId'
  | 'offer'
  | 'company'
  | 'applicant'
  | 'participant'
  | 'applicantCity'
  | 'startDate';

export interface BookingSearchFiltersV2 {
  searchTerm: string;
  offerId: string;
  companyId: string;
  applicant: string;
  participant: string;
  applicantCity: string;
  published: string;
  startDateFrom: string;
  startDateTo: string;
  dateFilterMode: BookingDateFilterModeWire;
  numberOfParticipants: string;
  includeCancelled?: boolean;
}

export const defaultBookingSearchFiltersV2: BookingSearchFiltersV2 = {
  searchTerm: '',
  offerId: '',
  companyId: '',
  applicant: '',
  participant: '',
  applicantCity: '',
  published: '',
  startDateFrom: '',
  startDateTo: '',
  dateFilterMode: 'startDate',
  numberOfParticipants: '',
  includeCancelled: false,
};

export interface BookingSearchMatch {
  field: BookingSearchMatchField;
  label: string;
}

export interface BookingSearchReservationListItem {
  id: number;
  applicantDisplayName: string;
  applicantCity?: string;
  participantDisplayNames: string[];
}

export interface BookingSearchListItem {
  id: number;
  bookingDateFrom: string;
  bookingDateTo: string;
  offerName: string;
  companyName?: string;
  numberOfParticipants: number;
  price: number;
  oldPrice: number;
  bookingStatusName: string;
  cancelledAtUtc?: string | null;
  published: boolean;
  reservations: BookingSearchReservationListItem[];
  searchMatches: BookingSearchMatch[];
}

export interface BookingSearchV2Request {
  searchTerm?: string;
  offerId?: number;
  companyId?: number;
  applicant?: string;
  participant?: string;
  applicantCity?: string;
  published?: boolean;
  startDateFrom?: string;
  startDateTo?: string;
  dateFilterMode: BookingDateFilterModeWire;
  numberOfParticipants?: number;
  includeCancelled?: boolean;
  pageNumber: number;
  pageSize: number;
}
